import * as REGEX from '../constants/Regex'
import {isNullOrEmpty} from './strings.utils'

export const validacionEsRequerido = (
  value: string,
  message: string,
  name: string = '',
  requerido: string = 'requerido'
): string => {
  if (isNullOrEmpty(value)) return `${name.charAt(0).toUpperCase()+name.slice(1)} es ${requerido}`
  return ''
}

export const validacionMaxLenght = (value: string, message: string, max: number): string => {
  if (value.length > max) return `Máximo permitido ${max} caracteres`
  return message
}

export const validacionMinLenght = (value: string, message: string, min: number): string => {
  if (min > value.length) return `Mínimo permitido ${min} caracteres`
  return message
}

export const validacionNIT = (value: string, message: string, name: string): string => {
  if (!REGEX.REGEX_NIT.test(value)) return `${name} inválido`
  return message
}

export const validacionNIT2 = (value: string, message: string, name: string): string => {
  if (!REGEX.REGEX_NIT2.test(value)) return `${name} inválido`
  return message
}

export const validacionPassword = (value: string, message: string, name: string): string => {
  if (!REGEX.REGEX_PASSWORD.test(value)) return `${name} inválida`
  return message
}

export const validacionEmail = (value: string, message: string, name: string): string => {
  if (!REGEX.REGEX_EMAIL.test(value)) return `${name} inválido`
  return message
}

export const validacionFechaNacMayor17 = (fecha: string, message: string, name: string): string => {
  let fecha_nacimiento = new Date(fecha)
  let fecha_Actual = new Date()
  let edad = (fecha_Actual.getTime() - fecha_nacimiento.getTime()) / (1000 * 60 * 60 * 24 * 365.25)

  if (edad >= 18) return ''
  return `${name} incorrecta, debe ser mayor de edad`
}

export const validacionRegex = (
  regex: RegExp,
  value: string,
  message: string,
  name: string = '',
  invalido: string = 'inválido'
): string => {
  if (!regex.test(value)) return `${name} ${invalido}`.trim()
  return message
}

export const validarTipoDocumento = (
  nombreTipoDocumento: string,
  value: string,
  message: string
) => {
  switch (nombreTipoDocumento.toLowerCase()) {
    case 'otro':
      message = validacionEsRequerido(value, message, nombreTipoDocumento)
      if (!message) message = svDocE(value)
      break
    case 'nit':
      message = validacionEsRequerido(value, message, nombreTipoDocumento)
      if (!message) message = validacionMinLenght(value, message, 9)
      if (!message) message = validacionNIT2(value, message, nombreTipoDocumento)
      break
    case 'dui':
      message = validacionEsRequerido(value, message, nombreTipoDocumento)
      if (!message) message = svDocB(value)
      break
    case 'pasaporte':
      message = validacionEsRequerido(value, message, nombreTipoDocumento)
      if (!message) message = svDocPasaporte(value)
      break
    case 'carnet de residente':
      message = validacionEsRequerido(value, message, nombreTipoDocumento)
      if (!message) message = svDocD(value)
      break
    default:
      message = ''
      break
  }
  return message
}

export const validacionNumMaximo = (value: string, exclusiveMaximum: number): string => {
  if (value && parseFloat(value) >= exclusiveMaximum) return `Debe ser menor a ${exclusiveMaximum}`
  return ''
}

export const validacionNumMinimo = (value: string, min: number): string => {
  if (value && parseFloat(value) <= min) return `Debe ser mayor a ${min}`
  return ''
}

// ------------------------------------------------------------------------------------------------------
// ? REGEX para tipos de Documento El Salvador
export const svDocA = (value: string) => {
  const regex = /^[0-9A-Z]{14}$/i
  if (!regex.test(value)) return 'Formato incorrecto de pasaporte'
  return ''
}

export const svDocB = (value: string) => {
  const regex = /^[0-9\s]{9}$/g
  if (!regex.test(value)) return 'Formato incorrecto de DUI'
  return ''
}

export const svDocBSemantico = (value: string) => {
  const regex = /(^\d{8})-(\d$)/
  let parts = value.match(regex)
  let flag = true

  if (parts !== null) {
    let digits = parts[1],
      dig_ve = parseInt(parts[2], 10),
      sum = 0

    // sumar producto de posiciones y digitos
    for (let i = 0, l = digits.length; i < l; i++) {
      let d = parseInt(digits[i], 10)
      sum += (9 - i) * d
    }
    flag = dig_ve === (10 - (sum % 10)) % 10
  } else flag = false

  if (!flag) return 'DUI no válido'
  return ''
}

export const svDocC = (value: string) => {
  const regex = /^([a-zA-Z0-9]{5,20})$/i
  if (!regex.test(value)) return 'Formato incorrecto de licencia de conducir'
  return ''
}

export const svDocD = (value: string) => {
  const regex = /^[0-9A-Z]{14}$/i
  if (!regex.test(value)) return 'Formato incorrecto de carnet de residente'
  return ''
}

export const svDocE = (value: string) => {
  const regex = /^([a-zA-Z0-9]{3,20})$/i
  if (!regex.test(value)) return 'Formato incorrecto de otros documentos'
  return ''
}

export const svDocF = (value: string) => {
  const regex = /^([0-9]{3,7})$/i
  if (!regex.test(value)) return 'Formato incorrecto de otros documentos'
  return ''
}

export const validarTipoDocumentoID = (tipoDoc: string, value: string) => {
  let message = ""
  switch (tipoDoc.toLowerCase()) {
    case '37':
      message = svDocE(value)
      break
    case '36':
      message = validacionNIT2(value, "", "")
      break
    case '13':
      message = svDocB(value)
      break
    case '03':
      message = svDocPasaporte(value)
      break
    case '02':
      message = svDocD(value)
      break
    default:
      message = ''
      break
  }
  return message
}

export const svDocPasaporte = (value: string) => {
  const regex = /^[A-Z0-9\\-]+$/i
  if (!regex.test(value)) return 'Formato incorrecto de pasaporte'
  return ''
}
